import React, { useState } from 'react';
import './FeedbackModal.css';

const FeedbackModal = ({ isOpen, onClose, onSave, slot }) => {
    const [text, setText] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        if (text.trim()) {
            onSave(slot, text.trim());
            setText('');
            onClose();
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Благодарим за участие</h3>
                <p>Слот: {new Date(slot.datetime).toLocaleString()}</p>

                {/* 
                <textarea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Ваш отзыв..."
                    className="modal-textarea"
                />
                */}

                <p style={{ marginTop: '20px', fontSize: '16px' }}>
                    Нам важно ваше мнение. Пожалуйста, оставьте отзыв о своём опыте участия, заполнив короткую форму по ссылке ниже:
                </p>

                <p style={{ marginTop: '10px' }}>
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSdkccTTCKN9Dag0vY0pwcwG_UmMhtVA5CIDn7Ls3zFKAfagrQ/viewform?usp=sf_link"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#2c3e50', fontWeight: 'bold', textDecoration: 'underline' }}
                    >
                        Перейти к форме отзыва
                    </a>
                </p>

                <div className="modal-actions">
                    <button className="btn cancel" onClick={onClose}>Закрыть</button>

                    {/* 
                    <button className="btn submit" onClick={handleSubmit}>Сохранить</button> 
                    */}
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
